/**
 * House of Places — email capture modal.
 *
 * Opens once, after a delay the merchant sets. The choice is remembered in
 * localStorage so a shopper who closed it — or who subscribed — is not asked
 * again on the next page.
 *
 * <dialog> carries the focus trap, the Escape key and inertness of the page
 * behind it, so none of that is reimplemented here.
 */
(function () {
  var popup = document.querySelector('[data-hop-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;

  var anahtar = popup.getAttribute('data-storage-key') || 'hop-email-popup';
  var gecikme = parseInt(popup.getAttribute('data-delay'), 10);
  if (isNaN(gecikme)) gecikme = 8;

  function okundu() {
    try {
      return localStorage.getItem(anahtar);
    } catch (e) {
      // Private mode can throw on access. Treat it as "never shown" rather
      // than failing — worst case the shopper sees it once per session.
      return null;
    }
  }

  function yaz(deger) {
    try {
      localStorage.setItem(anahtar, deger);
    } catch (e) {
      /* storage unavailable — nothing to remember, nothing to do */
    }
  }

  // A successful submit re-renders the page with the thank-you state. Record
  // it straight away so the modal never returns for a subscriber.
  if (popup.querySelector('[data-hop-popup-success]')) {
    yaz('subscribed');
    popup.showModal();
  } else if (!okundu()) {
    setTimeout(function () {
      // Don't interrupt someone mid-task in another dialog (cart drawer,
      // search modal): wait for the next chance instead of stacking.
      if (document.querySelector('dialog[open]')) return;
      if (tutamak) tutamak.hidden = true;
      popup.showModal();
    }, gecikme * 1000);
  }

  // The corner handle. Closing the modal is no longer the end of the offer —
  // the handle keeps it one click away, the way the reference store does it.
  // A subscriber never sees it; everyone else has it on every page.
  var tutamak = document.querySelector('[data-hop-popup-handle]');

  function tutamagiGoster() {
    if (tutamak && okundu() !== 'subscribed') tutamak.hidden = false;
  }

  function kapat() {
    yaz('dismissed');
    popup.close();
    tutamagiGoster();
  }

  // The handle is there from the first page view, not only after a
  // dismissal: before, a shopper who had not met the modal yet (or whose modal
  // was skipped because another dialog was open) saw no handle on that page,
  // so it seemed to come and go.
  tutamagiGoster();

  if (tutamak) {
    tutamak.addEventListener('click', function () {
      tutamak.hidden = true;
      popup.showModal();
    });
  }

  popup.querySelectorAll('[data-hop-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', kapat);
  });

  // Escape and the backdrop both count as "no thanks".
  popup.addEventListener('close', function () {
    if (okundu() !== 'subscribed') {
      yaz('dismissed');
      tutamagiGoster();
    }
  });

  popup.addEventListener('click', function (e) {
    if (e.target === popup) kapat();
  });
})();

/* "Which cities" answer -> extra customer tags on submit: "city: Paris".
   Separate tags (not the note) so requests can be filtered and counted in
   Customers. Capped at five cities of 40 characters each. */
(function () {
  var form = document.querySelector('[data-hop-popup] .hop-popup__form');
  if (!form) return;
  form.addEventListener('submit', function () {
    var alan = form.querySelector('[data-hop-popup-cities]');
    var etiket = form.querySelector('[data-hop-popup-tags]');
    if (!alan || !etiket) return;
    var sehirler = alan.value
      .split(/[,;\n]+/)
      .map(function (s) {
        return s.replace(/\s+/g, ' ').trim().slice(0, 40);
      })
      .filter(Boolean)
      .slice(0, 5);
    var etiketler = ['newsletter'].concat(
      sehirler.map(function (s) {
        return 'city: ' + s;
      })
    );
    etiket.value = etiketler.join(',');
  });
})();
